export default {
    'query.queryCard.h1':'全球物流查询平台',
    'query.queryCard.p':'达强物流查询系统，全程跟踪物流信息，提供清晰标准的轨迹状态节点，完整准确的轨迹信息，查询准确率达99%。',
    'query.queryCard.placeholder':'请输入单号,一行一个',
    'query.queryCard.submit':'查询',
    'query.stepsCard.item01.title':'精准追踪',
    'query.stepsCard.item01.desc':'全流程多渠道实时定位查询',
    'query.stepsCard.item02.title':'高效清关',
    'query.stepsCard.item02.desc':'多口岸清关极致高效',
    'query.stepsCard.item03.title':'尊享服务',
    'query.stepsCard.item03.desc':'仓内优先处理,顶级物流服务商',
    'query.stepsCard.item04.title':'品质保证',
    'query.stepsCard.item04.desc':'普货ONLY,安全稳定',
    'query.stepsCard.item05.title':'顶级物流',
    'query.stepsCard.item05.desc':'顶级物流服务商,尾程派送更安心',
    
}